import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import { Badge, IconButton, Tooltip } from "@mui/material";
import React, { FC } from "react";

import { useHelpInternal } from "../HelpContext";

const HelpButton: FC = () => {
  const { available, openDrawer, hasUnseenNewHere } = useHelpInternal();
  // Nothing to watch for this user (no permission for any video): no Help button at all.
  if (!available) return null;
  return (
    <Tooltip title="Help videos">
      <IconButton color="primary" onClick={openDrawer} size="small" aria-label="Help">
        <Badge color="primary" variant="dot" invisible={!hasUnseenNewHere}>
          <HelpOutlineIcon fontSize="small" />
        </Badge>
      </IconButton>
    </Tooltip>
  );
};

export default HelpButton;
